import { useId } from 'react'

export interface AreaDeTextoProps {
  etiqueta: string
  valor: string
  alCambiar: (valor: string) => void
  filas?: number
  ayuda?: string
  marcador?: string
  requerido?: boolean
  error?: string
}

export function AreaDeTexto(props: AreaDeTextoProps) {
  const id = useId()
  const descripciones = [props.ayuda ? `${id}-ayuda` : null, props.error ? `${id}-error` : null].filter(Boolean).join(' ')
  return (
    <div className="grid gap-1">
      <label htmlFor={id} className="text-pequeno font-semibold text-texto">
        {props.etiqueta}
        {props.requerido ? <span aria-hidden="true"> *</span> : null}
      </label>
      <textarea
        id={id}
        rows={props.filas ?? 4}
        value={props.valor}
        onChange={(e) => props.alCambiar(e.target.value)}
        placeholder={props.marcador}
        required={props.requerido}
        aria-invalid={props.error ? true : undefined}
        aria-describedby={descripciones || undefined}
        className="w-full rounded-md border border-borde bg-superficie px-3 py-2 text-cuerpo text-texto placeholder:text-texto-secundario"
      />
      {props.ayuda ? <p id={`${id}-ayuda`} className="text-pequeno text-texto-secundario">{props.ayuda}</p> : null}
      {props.error ? <p id={`${id}-error`} role="alert" className="text-pequeno text-critico-texto">{props.error}</p> : null}
    </div>
  )
}
